import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail, RotateCcw, X } from "lucide-react";
import { WhatsAppGlyph } from "@/components/cards/CardShell";
import { contractSignLink, errText, resignEmail, resignWa, voidContract } from "@/lib/bf";
import { waLink } from "@/lib/wa";

export default function BFVoidBox({ id, k, name, st, signed, tok, d, onDone }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const voided = !st && signed.find((s) => s.firm === k && s.status === "anulat");
  const go = () => {
    if (reason.trim().length < 3) return toast.error("Scrie motivul anulării");
    setBusy(true);
    voidContract(id, k, reason.trim()).then(() => { setOpen(false); setReason(""); onDone(); toast.success(`Contractul ${name} a fost anulat. Trimite clientului linkul de resemnare.`); })
      .catch((e) => toast.error(errText(e, "Nu am putut anula contractul"))).finally(() => setBusy(false));
  };
  const mail = () => { setBusy(true); resignEmail(id, k).then((r) => { onDone(); toast.success(`Linkul de resemnare a fost trimis la ${r.to}`); }).catch((e) => toast.error(errText(e, "Nu am putut trimite e-mailul"))).finally(() => setBusy(false)); };
  if (voided && tok) {
    const msg = `Bună ziua, ${d.admin}! Am refăcut contractul cu ${name} pentru ${d.firma}. Vă rugăm să îl semnați din nou, direct de pe telefon:\n\n${contractSignLink(tok)}\n\nDupă semnare primiți un e-mail la ${d.email}: apăsați „Confirm și trimit contractul”. Mulțumesc!`;
    return (
      <>
        <a className="st-btn st-btn--light" href={waLink(d.phone, msg)} onClick={() => resignWa(id, k).then(onDone).catch(() => {})} target="_blank" rel="noopener noreferrer" data-testid={`bf-resign-wa-${k}`}><WhatsAppGlyph /> Link de resemnare pe WhatsApp</a>
        <button type="button" className="st-btn st-btn--light" onClick={mail} disabled={busy} data-testid={`bf-resign-email-${k}`}>{busy ? <Loader2 size={14} className="animate-spin" /> : <Mail size={14} />} Trimite linkul pe e-mail</button>
      </>
    );
  }
  if (!st) return null;
  if (!open) return <button type="button" className="st-btn st-btn--ghost" onClick={() => setOpen(true)} data-testid={`bf-contract-void-${k}`}><RotateCcw size={14} /> Resemnează</button>;
  return (
    <form className="bf-void-box" onSubmit={(e) => { e.preventDefault(); go(); }} data-testid={`bf-void-box-${k}`}>
      <input value={reason} maxLength={200} autoFocus placeholder="Motivul anulării" onChange={(e) => setReason(e.target.value)} data-testid={`bf-void-reason-${k}`} />
      <button type="submit" className="st-btn st-btn--silver" disabled={busy} data-testid={`bf-void-confirm-${k}`}>{busy ? <Loader2 size={14} className="animate-spin" /> : <RotateCcw size={14} />} Anulează contractul</button>
      <button type="button" className="st-btn st-btn--ghost" onClick={() => setOpen(false)} disabled={busy} data-testid={`bf-void-cancel-${k}`}><X size={14} /> Renunță</button>
    </form>
  );
}
